import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile-edit-address',
  imports: [ReactiveFormsModule, TranslateModule, ImmomioFormFieldComponent],
  templateUrl: './user-profile-edit-address.component.html',
  styleUrl: './user-profile-edit-address.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class UserProfileEditAddressComponent {}
